// extracted by mini-css-extract-plugin
export var infoRow = "_um-2";
export var labelContainer = "_um-0";
export var rightInfo = "_um-1";